const FilterIcon = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6659 23.3333H5.33252"
        stroke="#992785"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6657 23.3333C26.6657 25.1742 25.1733 26.6666 23.3324 26.6666C21.4914 26.6666 19.999 25.1742 19.999 23.3333C19.999 21.491 21.4914 19.9999 23.3324 19.9999C25.1733 19.9999 26.6657 21.491 26.6657 23.3333Z"
        stroke="#0D2C6C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3325 8.66661H26.6659"
        stroke="#992785"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33252 8.66662C5.33252 10.5089 6.82489 11.9999 8.66585 11.9999C10.5068 11.9999 11.9992 10.5089 11.9992 8.66662C11.9992 6.82566 10.5068 5.33328 8.66585 5.33328C6.82489 5.33328 5.33252 6.82566 5.33252 8.66662Z"
        stroke="#0D2C6C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const CalendarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.966797 8.2786H18.7907"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9183 0.87439V4.16517"
      stroke="#0D2C6C"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.84015 0.87439V4.16517"
      stroke="#0D2C6C"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1123 2.45349H5.64499C2.7083 2.45349 0.874023 4.08942 0.874023 7.09652V16.1462C0.874023 19.2005 2.7083 20.8743 5.64499 20.8743H14.103C17.049 20.8743 18.874 19.2289 18.874 16.2218V7.09652C18.8833 4.08942 17.0582 2.45349 14.1123 2.45349Z"
      stroke="#0D2C6C"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5484 12.8506H14.5577"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1109 12.8506H10.1202"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66462 12.8506H5.67389"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5484 16.7371H14.5577"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1109 16.7371H10.1202"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66462 16.7371H5.67389"
      stroke="#992785"
      strokeWidth="1.7487"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export { FilterIcon, CalendarIcon }
